<template>
  <div v-if="this.$store.getters.isAdmin">
    <h2 class="text-center pb-10">Gestion des comptes utilisateurs Bosco</h2>
    <div class="p-5 mb-10" style="width:100%; background-color:white;">
      <div class="d-flex flex-row mt-5">
        <div v-if="selectedAvatar" class="col-lg-3 p-0 pb-4 pr-4">
          <img
            :src="selectedAvatar"
            style="width:100%; border-radius:5%"
            alt="avatar-tmg"
          />
        </div>
        <div class="d-flex flex-column justify-content-around col-lg-6">
          <div class="d-flex flex-row pb-5">
            <span class="text-dark-75 mr-2">{{$t("quickUser.firstname")}}:</span>
            <span class="text-muted">{{this.currentUser.firstname}}</span>
          </div>
          <div class="d-flex flex-row pb-5">
            <span class="text-dark-75 mr-2">{{$t("quickUser.name")}}:</span>
            <span class="text-muted">{{this.currentUser.lastname}}</span>
          </div>
          <div class="d-flex flex-row pb-5">
            <span class="text-dark-75 mr-2">{{$t("quickUser.email")}}:</span>
            <span class="text-muted">{{this.currentUser.email}}</span>
          </div>
          <div class="d-flex flex-row pb-5">
            <span class="text-dark-75 mr-2">{{$t("quickUser.role")}}:</span>
            <span class="text-muted">{{this.currentUser.roles[0]}}</span>
          </div>
        </div>

        <div class="d-flex flex-column justify-content-start col-lg-3 p-0">
          <a ref="btn-send-password" class="btn btn-primary" style="width:100%" @click="sendPassword">
          Initialiser votre mot de passe
          </a>
        </div>
      </div>
    </div>
    <v-tabs
      v-model="selectedTab"
      background-color="pink lighten-2"
      grow
      icons-and-text
      dark
      class="mb-10"
    >
      <v-tab href="#tab-users">
        Utilisateurs
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="selectedTab">
      <v-tab-item value="tab-users">
        <UsersBosco></UsersBosco>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UsersBosco from "@/components/admin/user/forms/tabs/usersBosco.vue";
import { mapGetters } from "vuex";
import Api from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "boscoManagement",
  components: {
    UsersBosco,
  },
  data: () => ({
    selectedTab: null,
    users: [],
    avatars: [
      "/media/svg/avatars/v1.jpg",
      "/media/svg/avatars/v2.jpg",
      "/media/svg/avatars/v3.jpg",
      "/media/svg/avatars/v4.jpg",
      "/media/svg/avatars/v5.jpg",
      "/media/svg/avatars/v6.jpg",
      "/media/svg/avatars/v7.jpg",
    ],
    selectedAvatar: null,
  }),
  watch: {
    selectedTab(value) {
      localStorage.selectedTab = value;
    }
  },
  created() {
    this.selectedAvatar = this.randomItem(this.avatars)
  },
  mounted() {
    if (localStorage.selectedTab) {
       this.selectedTab = localStorage.selectedTab;
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Administration", route: "gestionClients"},
      { title: "Gestion des comptes utilisateurs Bosco" },
    ]);
  },
  computed: {
    ...mapGetters([
      "currentUser",
    ]),
  },
  methods:{
    randomItem (items) {
      return items[Math.floor(Math.random()*items.length)];
    },
    sendPassword() {
      const sendPasswordButton = this.$refs["btn-send-password"];
      sendPasswordButton.classList.add("spinner", "spinner-light", "spinner-right");

      Api.post('/forgot_password/', {email: this.currentUser.email})
      .then(response => {
        if (response.status === 200) {
          Swal.fire({
            title: "",
            text: "Un mail contenant le nouveau mot de passe de l'utilisateur a bien été envoyé.",
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
        }
      })
      .finally(() => {
        sendPasswordButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
        );
      });
    }
  },
};
</script>
